// PM: Payment Method
import types from 'redux/types';
import Queue from 'helpers/queue';
import { checkTypeValue } from 'helpers';

const queueIdRequestingDefault = new Queue();

const initialState = {
  isFetchingHisCharge: false,
  isFetchedHisCharge: false,
  isFetchedListCard: false,
  isFetchingListCard: false,
  isSettingDefault: false,
  isAdding: false,
  isFetchingListPackage: false,
  isFetchedListPackage: false,
  isLoadMoreHistory: false,
  isLastHistory: false,

  listPackage: [],
  listCard: [],
  listHisCharge: [],
  paymentSelected: {},

  queueIdRequestingDefault: queueIdRequestingDefault.queue,

  errorFetchPackages: null,
  errorAddCard: null,
  errorFetchListCard: null,
  errorHisCharge: null,
  errorDefault: null,
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case types.REQUEST_GET_MORE_HISTORY_CHARGE:
      return {
        ...state,
        isLoadMoreHistory: true,
      };

    case types.REQUEST_GET_MORE_HISTORY_CHARGE_SUCCESS:
      return {
        ...state,
        isLastHistory: actions.isLastHistory,
        listHisCharge: [...state.listHisCharge, ...actions.data],
        errorGetMoreHistory: null,
        isLoadMoreHistory: false,
      };

    case types.REQUEST_GET_MORE_HISTORY_CHARGE_FAILED:
      return {
        ...state,
        errorGetMoreHistory: actions.error,
        isLoadMoreHistory: false,
      };

    case types.REQUEST_LIST_PACKAGE:
      return {
        ...state,
        isFetchingListPackage: true,
        isFetchedListPackage: false,
      };
    case types.REQUEST_LIST_PACKAGE_SUCCESS:
      return {
        ...state,
        listPackage: actions.data,
        isFetchingListPackage: false,
        isFetchedListPackage: true,
      };

    case types.REQUEST_LIST_PACKAGE_FAILED:
      return {
        ...state,
        errorFetchPackages: actions.error,
        isFetchedListPackage: false,
        isFetchingListPackage: false,
      };
    case types.REQUEST_MAKE_DEFAULT: {
      queueIdRequestingDefault.pushToQueue(actions.cardId);
      return {
        ...state,
        isSettingDefault: true,
        queueIdRequestingDefault: queueIdRequestingDefault.queue,
      };
    }

    case types.REQUEST_MAKE_DEFAULT_SUCCESS: {
      queueIdRequestingDefault.removeFromQueue(actions.cardId);
      return {
        ...state,
        isSettingDefault: false,
        errorDefault: null,
        queueIdRequestingDefault: queueIdRequestingDefault.queue,
      };
    }

    case types.REQUEST_MAKE_DEFAULT_FAILED: {
      queueIdRequestingDefault.removeFromQueue(actions.cardId);
      return {
        ...state,
        isSettingDefault: false,
        errorDefault: actions.error,
        queueIdRequestingDefault: queueIdRequestingDefault.queue,
      };
    }

    case types.REQUEST_GET_LIST_HISTORY_CHARGE:
      return {
        ...state,
        isFetchingHisCharge: true,
        isFetchedHisCharge: false,
      };

    case types.REQUEST_GET_LIST_HISTORY_CHARGE_SUCCESS:
      return {
        ...state,
        listHisCharge: actions.data,
        isLastHistory: actions.isLastHistory,
        isFetchingHisCharge: false,
        isFetchedHisCharge: true,
        errorHisCharge: null,
      };

    case types.REQUEST_GET_LIST_HISTORY_CHARGE_FAILED:
      return {
        ...state,
        isFetchingHisCharge: false,
        isFetchedHisCharge: false,
        errorHisCharge: actions.error,
      };

    case types.REQUEST_LIST_CARD:
      return {
        ...state,
        isFetchingListCard: true,
        isFetchedListCard: false,
      };

    case types.REQUEST_LIST_CARD_SUCCESS:
      return {
        ...state,
        isFetchingListCard: false,
        isFetchedListCard: true,
        listCard: actions.data,
        errorFetchListCard: null,
      };

    case types.REQUEST_LIST_CARD_FAILED:
      return {
        ...state,
        isFetchingListCard: false,
        isFetchedListCard: false,
        errorFetchListCard: actions.error,
      };

    case types.REQUEST_ADD_CARD_METHOD:
      return {
        ...state,
        isAdding: true,
      };

    case types.REQUEST_ADD_CARD_METHOD_SUCCESS:
      return {
        ...state,
        isAdding: false,
        errorAddCard: null,
      };

    case types.REQUEST_ADD_CARD_METHOD_FAILED:
      return {
        ...state,
        errorAddCard: actions.error,
        isAdding: false,
      };

    case types.REQUEST_PAYMENT_SELECTED:
      return {
        ...state,
        paymentSelected: actions.payload,
      };

    case types.RESET_FORM_CARD:
      return {
        ...state,
        errorAddCard: null,
        isAdding: false,
      };

    default:
      return state;
  }
};
